module.exports = __webpack_public_path__ + "static/hardwarebanner-2-40828ea4f8f4813a2b96cba41ad76518.png";